export enum RouteSeverity {
    Contraindicated = 1,
    NotRecommended = 2,
}